import { Center } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useColor } from '../../theme'
import {
  TILE_HEIGHT,
  TILE_BORDER_RADIUS,
  DEFAULT_TILE_WIDTH,
  TILE_PADDING,
} from './Tile'

const TileError: FC<{ message: string }> = ({ message }) => {
  const backgroundColor = useColor({
    nuance: 'red',
    palette: 'colors',
  })

  return (
    <Center
      backgroundColor={backgroundColor}
      borderRadius={TILE_BORDER_RADIUS}
      color="white"
      fontSize="sm"
      height={TILE_HEIGHT}
      padding={TILE_PADDING}
      textAlign="center"
      width={DEFAULT_TILE_WIDTH}>
      {message}
    </Center>
  )
}

export { TileError }
